import { LogoColour } from '@/components/shared/Logo'
import { trackCtaClick } from '@/lib/gtm/gtmV2'
import { Banner, BANNER_HEIGHT_DESKTOP, BANNER_HEIGHT_MOBILE } from '@/components/ds/Navigation/Banner'
import styled from 'styled-components'
import { BREAKPOINTS } from '@/components/ds/breakpoints'
import { useBanner } from '@/context/bannerContext'
import { Navigation } from '@/components/ds/Navigation/NewNavigation'

export const StyledBannerSpacer = styled.div`
  min-height: ${BANNER_HEIGHT_DESKTOP}px;
  @media screen and (max-width: ${BREAKPOINTS.m}) {
    height: ${BANNER_HEIGHT_MOBILE}px;
  }
`

export type HeaderProps = {
  iconColour?: LogoColour
  backgroundColor?: string
  minimal?: boolean
  withBorder?: boolean
  featuredBanner?: boolean
  bannerHeight?: number | null
  onDarkBackground?: boolean
  hideCta?: boolean
  ctaText?: string
  ctaHref?: string
  onCtaPress?: () => void
  withTopBanner?: boolean
  secondaryCtaLabel?: string
  onSecondaryCtaPress?: () => void
}

export const Header = ({
  iconColour = 'brand',
  backgroundColor = 'transparent',
  minimal,
  featuredBanner = false,
  bannerHeight,
  onDarkBackground = false,
  hideCta = false,
  ctaText,
  ctaHref,
  onCtaPress,
  secondaryCtaLabel,
  onSecondaryCtaPress,
  withTopBanner,
}: HeaderProps) => {
  const { bannerContent } = useBanner()

  const trackNavItemClick = (label: string) => {
    trackCtaClick('navbar_header', label, { link_position: 'header' })
  }

  const trackNavCtaClick = () => {
    trackCtaClick('navbar_header', ctaText || '', { link_position: 'header' })
  }

  return (
    <>
      <noscript
        dangerouslySetInnerHTML={{
          __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NFJ9482N"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
        }}
      ></noscript>
      {bannerContent?.enabled && <Banner text={bannerContent?.text} />}
      <Navigation
        menuLabel="Menu"
        secondaryCtaLabel={secondaryCtaLabel || 'Login'}
        logoVariant={iconColour === 'dark' ? 'primary' : 'brand'}
        onMenuPress={() => trackNavItemClick('Menu')}
        onLogoPress={() => trackNavItemClick('Logo')}
        onSecondaryCtaPress={() => {
          onSecondaryCtaPress && onSecondaryCtaPress()
          trackNavItemClick(secondaryCtaLabel || 'Login')
        }}
        withTopBanner={withTopBanner || !!bannerContent?.enabled}
        links={[
          {
            href: '/buymembership',
            onPress: () => trackNavItemClick('Test kit & Membership'),
            text: 'Test kit & Membership',
          },
          {
            text: 'Daily30+',
            href: '/daily30',
            onPress: () => trackNavItemClick('Daily30+'),
            badge: 'New',
          },
          {
            href: '/our-science',
            onPress: () => trackNavItemClick('Our science'),
            text: 'Our science',
          },
          {
            href: '/menoscale',
            onPress: () => trackNavItemClick('MenoScale'),
            text: 'MenoScale',
          },
          {
            href: '/learn',
            onPress: () => trackNavItemClick('Library'),
            text: 'Library',
          },
          {
            href: '/faqs',
            onPress: () => trackNavItemClick('FAQs'),
            text: 'FAQs',
          },
        ]}
        ctaLabel={ctaText}
        ctaHref={ctaHref}
        onCtaPress={onCtaPress || trackNavCtaClick}
      />
      {bannerContent?.enabled && <StyledBannerSpacer />}
    </>
  )
}
